import type { JSX } from 'react';
import { uniq } from 'lodash';
import { useEffect, useState } from 'react';
import type { ProcessActorProfession } from '@common/interfaces/processActors';
import { ProcessContext } from '@frontend/components/pages/episodeCategory/carePath/process/processContext';
import { getProcessActors } from '@frontend/services/api/processesApiService';
import { useAbortSignal } from '@frontend/utils/hooks/useAbortSignal';
import { useDefinedContext } from '@frontend/utils/hooks/useDefinedContext';
import { SelectProcessActivityPerformer } from './SelectProcessActivityPerformer';

export type SelectProcessActivityPerformerFromProcessActorOrganizationProps = Readonly<{
    profession: ProcessActorProfession;
    recipientActivityIds: string[];
}>;

export function SelectProcessActivityPerformerFromProcessActorOrganization(
    props: SelectProcessActivityPerformerFromProcessActorOrganizationProps
): JSX.Element | null {
    const abortSignal = useAbortSignal();
    const { process } = useDefinedContext(ProcessContext);
    const [organizationIds, setOrganizationIds] = useState<string[]>([]);

    useEffect(() => {
        findOneProcessActorOrganization(process.id);
    }, [process.id]);

    if (!organizationIds.length) {
        return null;
    }

    return (
        <SelectProcessActivityPerformer
            organizationIds={organizationIds}
            recipientActivityIds={props.recipientActivityIds}
            serviceId={process.service.id}
        />
    );

    async function findOneProcessActorOrganization(processId: string) {
        const { items } = await getProcessActors(
            processId,
            {
                profession: props.profession,
            },
            abortSignal
        );

        const uniqueOrganizationIds = uniq(items.map((item) => item.organizationId));
        if (!uniqueOrganizationIds.length) {
            throw new Error(`Expected to find organizations`);
        }
        setOrganizationIds(uniqueOrganizationIds);
    }
}
